import { NotificationsTheme as DefaultNotificationsTheme } from "@acin.reactjs/acin-ui/notifications";
import { DefaultTheme } from "styled-components";

const NotificationsTheme = (
  theme: DefaultTheme,
): DefaultNotificationsTheme => ({
  badge: {
    root: { svg: { width: "20px", height: "20px" } },
    content: {
      root: {
        backgroundColor: theme.palette.status.error[500],
        transform: "translate(5px, -9px) !important",
      },
    },
  },
  dropdown: {
    actions: {
      clearAll: {
        fontSize: "14px",
        color: theme.palette.greys[600],
        fontWeight: 500,
      },
      showAll: {
        fontSize: "14px",
        color: theme.palette.common.black,
        fontWeight: 600,
      },
    },
    title: {
      fontSize: "12px",
      color: theme.palette.greys[400],
      fontWeight: 500,
    },
  },
  notification: {
    root: {
      padding: "8px 16px 8px 12px",
    },

    divider: {
      display: "none",

      "&:last-of-type": {
        display: "block",
        margin: "0px",
        borderBottom: `1px solid ${theme.palette.greys[50]}`,
      },
    },
    title: {
      root: {
        fontSize: "14px",
        fontWeight: 600,
        color: theme.palette.common.black,
        textTransform: "uppercase",
      },
      closeIcon: {
        root: { width: "16px", height: "16px", fill: theme.palette.greys[400] },
      },
      status: {
        notSeen: {
          backgroundColor: theme.palette.primary[700],
        },
      },
      container: {
        "& > :not(:first-child)": {
          marginLeft: "12px",
        },
      },
    },
    description: {
      fontSize: "14px",
      color: theme.palette.common.black,
      margin: "4px 20px",
      maxHeight: "34px",
    },
    age: {
      fontSize: "12px",
      color: theme.palette.greys[600],
      margin: "4px 20px 0px",
    },
    hover: {
      backgroundColor: theme.palette.primary[50],
    },
  },
});

export default NotificationsTheme;
